import React, { useState, useEffect } from 'react';
import { Form, Input, Button, notification, Typography, Divider } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import logo from '../../../images/sleasing-logo-primary 1.svg';

const { Title } = Typography;

const ResetPassword = ({ actions }) => {
  const location = useLocation();

  const [form] = Form.useForm();

  const status = new URLSearchParams(location.search).get('status');

  useEffect(() => {
    if (status === 'temporaryPassword') {
      notification.warning({
        message: 'Temporary Password',
        description: 'You must change your password as it is temporary.',
      });
    } else if (status === 'expiredPassword') {
      notification.warning({
        message: 'Expired Password',
        description: 'Your password has expired. Please change your password.',
      });
    }
  }, [status]);

  const onFinish = values => {
    const { email, oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      notification.error({
        message: 'Passwords do not match!',
      });
      return;
    }

    actions.resetPassword({ email, oldPassword, newPassword });
  };

  return (
    <div className="flex h-screen bg-dark-blue">
      <div className="bg-login-white w-[450px] h-[600px] m-auto rounded-md shrink-0">
        <img className="mt-16 m-auto" src={logo} alt="Logo" />
        <Title className="text-center text-sm text-dark-blue mt-3">
          LEASING KALKULATOR
        </Title>
        <Form
          className="px-11"
          name="changePassword"
          onFinish={onFinish}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
          form={form}
        >
          <Title
            className="w-fit font-normal text-light-blue-login border-b-2 border-light-blue-login"
            level={5}
          >
            {status === 'temporaryPassword'
              ? 'Promijenite privremenu lozinku'
              : status === 'expiredPassword'
              ? 'Promijenite istekla lozinka'
              : 'Promijenite vašu lozinku'}
          </Title>
          <Divider className="mt-0" />
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                type: 'email',
                message: 'Molimo unesite vaš email!',
              },
            ]}
          >
            <Input
              prefix={<MailOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item
            name="oldPassword"
            rules={[
              {
                required: true,
                message: 'Molimo unesite vašu staru lozinku!',
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="Stara lozinka"
              visibilityToggle={false}
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            rules={[
              {
                required: true,
                message: 'Unesite novu lozinku!',
              },
              {
                min: 8,
                message: 'Lozinka mora imati najmanje 8 karaktera.',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.resolve();
                  }

                  const groups = [
                    /[A-Z]/.test(value),
                    /[a-z]/.test(value),
                    /\d/.test(value),
                    /[^A-Za-z0-9]/.test(value),
                  ];

                  const validGroups = groups.filter(Boolean).length;

                  if (validGroups >= 3) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      'Lozinka mora imati karaktere iz najmanje 3 od 4 grupe: velika slova (A-Z), mala slova (a-z), brojevi (0-9), specijalni znakovi.'
                    )
                  );
                },
              }),
            ]}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="Nova lozinka"
              visibilityToggle={false}
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Molimo potvrdite vašu lozinku!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('Dvije unesene lozinke se ne podudaraju!')
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="Potvrdite lozinku"
              visibilityToggle={false}
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="bg-light-blue-login w-fit text-white text-[16px] font-bold h-10"
              htmlType="submit"
            >
              Promijenite lozinku
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
